// extracted by mini-css-extract-plugin
export default {"AddRowButtonContainer":"_AddRowButtonContainer--GRVzh","ProductSumBoxContainer":"_ProductSumBoxContainer--xeWyZ","ProductSummation":"_ProductSummation--YTgrn"};